import React from "react";
import Card, { CardHeader } from "components/card";
import { EmptyState } from "components/states";
import { formatNumber } from "utils/format";
import DistributionBar from "./DistributionBar";
import StatTile from "./StatTile";

const SCALE_VALUES = [5, 4, 3, 2, 1];

// Low scores (1-2) read as danger, neutral 3 as muted, favorable 4-5 as success.
const getBarColor = (value) => {
  if (value <= 2) return "bg-danger";
  if (value === 3) return "bg-fg-muted/50";
  return "bg-success";
};

const SliderDistributionCard = ({ stats }) => {
  const { mean, median, count, favorablePercent, distribution } = stats || {};

  if (!count || count === 0) {
    return (
      <Card padding="md">
        <EmptyState variant="inline" title="No responses yet" />
      </Card>
    );
  }

  const favorableCount = (distribution?.[4]?.count || 0) + (distribution?.[5]?.count || 0);

  return (
    <div className="flex flex-col gap-5">
      <dl className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <StatTile label="Avg Score" value={mean ?? "N/A"} />
        <StatTile label="Median" value={median ?? "N/A"} />
        <StatTile label="Responses" value={formatNumber(count)} />
        <StatTile
          label="Favorable (4-5)"
          value={favorablePercent != null ? `${favorablePercent}%` : "N/A"}
          caption={
            favorablePercent != null
              ? `${formatNumber(favorableCount)} of ${formatNumber(count)} responses`
              : undefined
          }
        />
      </dl>

      <Card padding="md">
        <CardHeader
          title="Response Distribution"
          titleAs="h4"
          description={`Out of ${formatNumber(count)} responses`}
        />
        <ul className="mt-4 space-y-3">
          {SCALE_VALUES.map((value) => {
            const data = distribution?.[value] || { count: 0, percent: 0 };
            return (
              <DistributionBar
                key={value}
                label={value}
                percent={data.percent}
                count={data.count}
                barClassName={getBarColor(value)}
                labelClassName="w-6"
              />
            );
          })}
        </ul>
      </Card>
    </div>
  );
};

export default SliderDistributionCard;
